@if (remoteContent$ | async; as content) {
  @if ((isITMultiReceivingToggleOn$ | async) && isInternalTransfer) {
    @let accountNumber = accountNumber$ | async;
    <app-progress-header
      [accountHat]="accountNumber ? content.accountHatPrefix + accountNumber : null"
      [value]="2"
      [maxValue]="7"
      [labelText]="content.progressLabelITOpenAccount">
    </app-progress-header>
  }
  <div>
    <app-layout-default>
      <div>
        <h1 data-cy="contactInfoPageTitle" class="c11n-text-2xl-headline margin-bottom-3" [innerHTML]="content.pageTitle">
        </h1>
        <p data-cy="useOfResidenceMsg" class="margin-bottom-2" [innerHTML]="content.useOfResidenceMsg"></p>
        <onb-mfe-personal-address [setData]="setData" [context]="mfeContext" (getData)="getData($event)" ></onb-mfe-personal-address>
        <onb-mfe-phone [setData]="phoneSetData" (getData)="getPhoneMfeData($event)"></onb-mfe-phone>
        <div class="secure-link row">
          <onb-mfe-secure-link></onb-mfe-secure-link>
        </div>
      </div>
      <div layout-last-column>
        @if (!((isITMultiReceivingToggleOn$ | async) && isInternalTransfer)) {
          <c11n-button id="contactInfoBTN" (clickEvent)="nextPage()" [labelText]="content.continueButton" fullWidth="true">
          </c11n-button>
          <app-cancel></app-cancel>
        }
        <app-feedback-survey></app-feedback-survey>
      </div>
    </app-layout-default>
  </div>
  @if ((isITMultiReceivingToggleOn$ | async) && isInternalTransfer) {
    <app-footer-nav (backClicked)="previousPage()" (continueClicked)="nextPage()"></app-footer-nav>
  }
}
